var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$vuetify.breakpoint.xsOnly)?_c('MobileFullPageLayout'):_c('AppLayout')
}
var staticRenderFns = []

export { render, staticRenderFns }